<div class="login-page" [agprLoading]="waitingForLogin" [agprGlobalLoading]="true">
    <h1 class="u-srOnly">{{ 'Core.login.signIn' | localize }}</h1>
    <div
        class="login-sidebar {{partnerReseller}}"
        [ngClass]="{'login-sidebar-reseller': isResellerDomain}"
    >
        <div class="login-form">
            <img *ngIf="!!logoUrl" [src]="logoUrl" [alt]="logoAltText | localize" class="login-logo"/>
            <div *ngIf="!logoUrl" class="login-header">{{ 'Core.login.reseller.signIn' | localize }}</div>
            <agpr-message
                *ngIf="displayRequiredError"
                [severity]="messageSeverityEnum.error"
            >
                {{ 'Core.login.requiredFields' | localize }}
            </agpr-message>
            <agpr-message
                *ngIf="displayMultiSessionError"
                [severity]="messageSeverityEnum.error"
            >
                <p>{{ 'Core.login.multiSessionLine1' | localize }}</p>
                <p>{{ 'Core.login.multiSessionLine2' | localize }}</p>
                <ul class="agpr-loginError-list">
                    <li>{{ 'Core.login.multiSessionList1' | localize }}</li>
                    <li>
                        <agpr-button
                            class="agpr-login-link"
                            [style]="buttonTypes.link"
                            label="Core.login.multiSessionList2ButtonText"
                        ></agpr-button>
                        {{ 'Core.login.multiSessionList2AfterButton' | localize }}
                    </li>
                </ul>
            </agpr-message>
            <agpr-message
                *ngIf="displayAuthError"
                [severity]="messageSeverityEnum.error"
            >
                <ng-container *ngIf="failedAttempts < 3 && !lockedOut">
                    {{ 'Core.login.wrongPass' | localize }}
                </ng-container>
                <ng-container *ngIf="failedAttempts >= 3 && !lockedOut">
                    {{ 'Core.login.lockedOutSoon' | localize }}
                </ng-container>
                <ng-container *ngIf="lockedOut">
                    {{ 'Core.login.lockedOut' | localize }}
                </ng-container>
            </agpr-message>
            <agpr-message
                *ngIf="displayNoSsoError"
                [severity]="messageSeverityEnum.error"
            >
                {{ 'Core.sso.login.error.noSso' | localize }}
            </agpr-message>
            <agpr-message
                *ngIf="displayForbiddenError"
                [severity]="messageSeverityEnum.error"
            >
                {{ 'Core.login.forbiddenError' | localize }}
            </agpr-message>

            <ng-container *ngIf="!displaySessionLimitError">
                <ng-container
                    [formGroup]="commonLoginForm"
                >
                    <div class="login-username">
                        <!-- TODO make chrome prompt to save password -->
                        <agpr-text-input
                            formControlName="username"
                            [id]="'core_loginInfo_username'"
                            label="Core.login.email"
                            name="username"
                            type="text"
                            placeholder="Core.login.placeholderUser"
                            (keyup)="onEnter($event)"
                        ></agpr-text-input>
                    </div>
                    <div class="login-password">
                        <agpr-text-input
                            formControlName="password"
                            [id]="'core_loginInfo_password'"
                            label="Core.login.password"
                            type="password"
                            name="password"
                            placeholder="Core.login.placeholderPassword"
                            (keyup)="onEnter($event)"
                        ></agpr-text-input>
                        <a
                            class="login-forgot"
                            [href]="forgotUrl"
                        >
                            {{ 'Core.login.forgot' | localize }}
                        </a>

                    </div>
                    <agpr-button
                        *ngIf="!isResellerDomain || partnerReseller !== partnerResellerEnum.paMedia"
                        label="Core.login.signIn"
                        (click)="signIn()"
                        class="agpr-login-loginButton"
                        [style]="buttonTypes.primary">
                    </agpr-button>
                    <ng-container *ngIf="!isResellerDomain || partnerReseller === partnerResellerEnum.burrelles || partnerReseller === partnerResellerEnum.refmedia">
                        <div class="divide">
                            <span> {{ 'Core.sso.login.or' | localize }} </span>
                        </div>
                        <a
                            class="agility-link"
                            routerLink="/ssoLogin"
                        >
                            {{ 'Core.sso.login.signInWithSso' | localize }}
                        </a>
                    </ng-container>
                    <a
                        *ngIf="partnerReseller === partnerResellerEnum.paMedia"
                        class="reseller-frame-button"
                        [href]="resellerConfig?.buttonLink"
                    > {{ resellerConfig?.buttonLabel | localize }} </a>
                </ng-container>
            </ng-container>
            <ng-container
                *ngIf="displaySessionLimitError"
            >
                <agpr-message
                    [severity]="messageSeverityEnum.warning"
                >
                    <p>{{ 'Core.login.sessionLimitLine1' | localize }}</p>
                    <p>{{ 'Core.login.sessionLimitLine2' | localize }}</p>
                </agpr-message>
                <agpr-button
                    label="Core.login.sessionLimit.continue"
                    (click)="signIn(true)"
                    class="agpr-login-loginButton agpr-login-continueButton"
                    [style]="buttonTypes.secondary">
                </agpr-button>

                <a
                    class="agility-link agpr-login-cancelButton"
                    tabindex="0"
                    (keydown.enter)="clearErrorMessages()"
                    (click)="clearErrorMessages()"
                >
                    {{ 'Core.button.cancel' | localize }}
                </a>
            </ng-container>
        </div>
        <div class="login-footer">
            <a
                *ngIf="partnerReseller !== partnerResellerEnum.burrelles && partnerReseller !== partnerResellerEnum.refmedia"
                class="login-productHelp"
                target="_blank"
                href="https://www.agilitypr.com/contact/"
            >
                {{ 'Core.login.productHelp' | localize }}
            </a>
            <div *ngIf="isResellerDomain && partnerReseller !== partnerResellerEnum.paMedia" class="{{partnerReseller}} agpr-branding-poweredBy"></div>
            <a
                *ngIf="isResellerDomain && partnerReseller === partnerResellerEnum.paMedia"
                class="{{partnerReseller}} agpr-branding-poweredBy"
                href="https://app.agilitypr.com/app/login?noRedirect"
                alt="Agility Login"
            >

            </a>
            <div *ngIf="!isResellerDomain" [innerHTML]="'Agility.copyright' | localize"></div>
            <div *ngIf="isResellerDomain">{{'Core.login.reseller.copyright' | localize}}</div>
            <div *ngIf="!!resellerConfig?.copyright" [innerHTML]="resellerConfig?.copyright | localize" class="reseller-copyright"></div>
        </div>
    </div>
    <div class="marketing-iframe">
        <!-- TODO : Use different URL based on environment ? -->
        <iframe
            *ngIf="!isResellerDomain"
            [title]="'Login.marketingIframe.title' | localize"
            src="https://www.agilitypr.com/login-background/"
            sandbox="allow-same-origin allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
            scrolling="no"
            class="u-full-width u-full-height u-iframe-unstyled u-no-borders">
        </iframe>
        @if(partnerReseller !== partnerResellerEnum.refmedia){
        <ng-container *ngTemplateOutlet="isResellerDomain ? reseller : null; context: resellerConfig"></ng-container>
        }
    </div>
</div>

<ng-template #reseller>
    <div class="{{resellerConfig?.reseller}} reseller-frame">
        <div class="reseller-frame-header">{{'Core.login.reseller.header' | localize: {name: resellerConfig.name} }}</div>
        <div class="reseller-frame-subheader" *ngIf="!resellerConfig?.customSubheading">{{'Core.login.reseller.subheader' | localize: {name: resellerConfig.name} }}</div>
        <div class="reseller-frame-subheader" *ngIf="resellerConfig?.customSubheading" [innerHTML]="resellerConfig?.customSubheading | localize"></div>
        <div class="reseller-frame-list" *ngIf="!!resellerConfig.points">
            <ul>
                <li *ngFor="let point of resellerConfig?.points">
                    <span class="reseller-frame-list-icon fa-regular fa-duotone {{point.icon}}"></span>
                    <span>{{point.text | localize}}</span>
                </li>
            </ul>
        </div>
        <a
            *ngIf="!!resellerConfig?.buttonLink"
            class="reseller-frame-button"
            [href]="resellerConfig?.buttonLink"
            target="_blank"
        >{{ resellerConfig?.buttonLabel | localize }}</a>
    </div>
</ng-template>

